/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PekosRouteImport } from './routes/pekos'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as DiscoverRouteImport } from './routes/discover'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AuthorizeRouteImport } from './routes/authorize'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SeedsIndexRouteImport } from './routes/seeds/index'
import { Route as AtChar123ownerChar125IndexRouteImport } from './routes/@{$owner}/index'
import { Route as TemplatesSplatRouteImport } from './routes/templates_.$'
import { Route as SeedsNewRouteImport } from './routes/seeds/new'
import { Route as SeedsSplatRouteImport } from './routes/seeds/$'
import { Route as GIdRouteImport } from './routes/g.$id'
import { Route as DashboardSeedsRouteImport } from './routes/dashboard_.seeds'
import { Route as DashboardRuntimesRouteImport } from './routes/dashboard_.runtimes'
import { Route as BundlesSplatRouteImport } from './routes/bundles_.$'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AtChar123ownerChar125NameRouteImport } from './routes/@{$owner}/$name'
import { Route as OwnerNameRouteImport } from './routes/$owner/$name'
import { Route as PekoOwnerPekoNameRouteImport } from './routes/peko.$owner.$pekoName'
import { Route as POwnerPrincipalNameRouteImport } from './routes/p.$owner.$principalName'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PekosRoute = PekosRouteImport.update({
  id: '/pekos',
  path: '/pekos',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscoverRoute = DiscoverRouteImport.update({
  id: '/discover',
  path: '/discover',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthorizeRoute = AuthorizeRouteImport.update({
  id: '/authorize',
  path: '/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SeedsIndexRoute = SeedsIndexRouteImport.update({
  id: '/seeds/',
  path: '/seeds/',
  getParentRoute: () => rootRouteImport,
} as any)
const AtChar123ownerChar125IndexRoute =
  AtChar123ownerChar125IndexRouteImport.update({
    id: '/@{$owner}/',
    path: '/@{$owner}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TemplatesSplatRoute = TemplatesSplatRouteImport.update({
  id: '/templates_/$',
  path: '/templates/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SeedsNewRoute = SeedsNewRouteImport.update({
  id: '/seeds/new',
  path: '/seeds/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SeedsSplatRoute = SeedsSplatRouteImport.update({
  id: '/seeds/$',
  path: '/seeds/$',
  getParentRoute: () => rootRouteImport,
} as any)
const GIdRoute = GIdRouteImport.update({
  id: '/g/$id',
  path: '/g/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSeedsRoute = DashboardSeedsRouteImport.update({
  id: '/dashboard_/seeds',
  path: '/dashboard/seeds',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRuntimesRoute = DashboardRuntimesRouteImport.update({
  id: '/dashboard_/runtimes',
  path: '/dashboard/runtimes',
  getParentRoute: () => rootRouteImport,
} as any)
const BundlesSplatRoute = BundlesSplatRouteImport.update({
  id: '/bundles_/$',
  path: '/bundles/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AtChar123ownerChar125NameRoute =
  AtChar123ownerChar125NameRouteImport.update({
    id: '/@{$owner}/$name',
    path: '/@{$owner}/$name',
    getParentRoute: () => rootRouteImport,
  } as any)
const OwnerNameRoute = OwnerNameRouteImport.update({
  id: '/$owner/$name',
  path: '/$owner/$name',
  getParentRoute: () => rootRouteImport,
} as any)
const PekoOwnerPekoNameRoute = PekoOwnerPekoNameRouteImport.update({
  id: '/peko/$owner/$pekoName',
  path: '/peko/$owner/$pekoName',
  getParentRoute: () => rootRouteImport,
} as any)
const POwnerPrincipalNameRoute = POwnerPrincipalNameRouteImport.update({
  id: '/p/$owner/$principalName',
  path: '/p/$owner/$principalName',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/authorize': typeof AuthorizeRoute
  '/dashboard': typeof DashboardRoute
  '/device': typeof DeviceRoute
  '/discover': typeof DiscoverRoute
  '/download': typeof DownloadRoute
  '/pekos': typeof PekosRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/status': typeof StatusRoute
  '/terms': typeof TermsRoute
  '/$owner/$name': typeof OwnerNameRoute
  '/@{$owner}/$name': typeof AtChar123ownerChar125NameRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/bundles/$': typeof BundlesSplatRoute
  '/dashboard/runtimes': typeof DashboardRuntimesRoute
  '/dashboard/seeds': typeof DashboardSeedsRoute
  '/g/$id': typeof GIdRoute
  '/seeds/$': typeof SeedsSplatRoute
  '/seeds/new': typeof SeedsNewRoute
  '/templates/$': typeof TemplatesSplatRoute
  '/@{$owner}/': typeof AtChar123ownerChar125IndexRoute
  '/seeds/': typeof SeedsIndexRoute
  '/p/$owner/$principalName': typeof POwnerPrincipalNameRoute
  '/peko/$owner/$pekoName': typeof PekoOwnerPekoNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/authorize': typeof AuthorizeRoute
  '/dashboard': typeof DashboardRoute
  '/device': typeof DeviceRoute
  '/discover': typeof DiscoverRoute
  '/download': typeof DownloadRoute
  '/pekos': typeof PekosRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/status': typeof StatusRoute
  '/terms': typeof TermsRoute
  '/$owner/$name': typeof OwnerNameRoute
  '/@{$owner}/$name': typeof AtChar123ownerChar125NameRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/bundles/$': typeof BundlesSplatRoute
  '/dashboard/runtimes': typeof DashboardRuntimesRoute
  '/dashboard/seeds': typeof DashboardSeedsRoute
  '/g/$id': typeof GIdRoute
  '/seeds/$': typeof SeedsSplatRoute
  '/seeds/new': typeof SeedsNewRoute
  '/templates/$': typeof TemplatesSplatRoute
  '/@{$owner}': typeof AtChar123ownerChar125IndexRoute
  '/seeds': typeof SeedsIndexRoute
  '/p/$owner/$principalName': typeof POwnerPrincipalNameRoute
  '/peko/$owner/$pekoName': typeof PekoOwnerPekoNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/authorize': typeof AuthorizeRoute
  '/dashboard': typeof DashboardRoute
  '/device': typeof DeviceRoute
  '/discover': typeof DiscoverRoute
  '/download': typeof DownloadRoute
  '/pekos': typeof PekosRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/status': typeof StatusRoute
  '/terms': typeof TermsRoute
  '/$owner/$name': typeof OwnerNameRoute
  '/@{$owner}/$name': typeof AtChar123ownerChar125NameRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/bundles_/$': typeof BundlesSplatRoute
  '/dashboard_/runtimes': typeof DashboardRuntimesRoute
  '/dashboard_/seeds': typeof DashboardSeedsRoute
  '/g/$id': typeof GIdRoute
  '/seeds/$': typeof SeedsSplatRoute
  '/seeds/new': typeof SeedsNewRoute
  '/templates_/$': typeof TemplatesSplatRoute
  '/@{$owner}/': typeof AtChar123ownerChar125IndexRoute
  '/seeds/': typeof SeedsIndexRoute
  '/p/$owner/$principalName': typeof POwnerPrincipalNameRoute
  '/peko/$owner/$pekoName': typeof PekoOwnerPekoNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/authorize'
    | '/dashboard'
    | '/device'
    | '/discover'
    | '/download'
    | '/pekos'
    | '/privacy'
    | '/profile'
    | '/search'
    | '/status'
    | '/terms'
    | '/$owner/$name'
    | '/@{$owner}/$name'
    | '/auth/callback'
    | '/bundles/$'
    | '/dashboard/runtimes'
    | '/dashboard/seeds'
    | '/g/$id'
    | '/seeds/$'
    | '/seeds/new'
    | '/templates/$'
    | '/@{$owner}/'
    | '/seeds/'
    | '/p/$owner/$principalName'
    | '/peko/$owner/$pekoName'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/authorize'
    | '/dashboard'
    | '/device'
    | '/discover'
    | '/download'
    | '/pekos'
    | '/privacy'
    | '/profile'
    | '/search'
    | '/status'
    | '/terms'
    | '/$owner/$name'
    | '/@{$owner}/$name'
    | '/auth/callback'
    | '/bundles/$'
    | '/dashboard/runtimes'
    | '/dashboard/seeds'
    | '/g/$id'
    | '/seeds/$'
    | '/seeds/new'
    | '/templates/$'
    | '/@{$owner}'
    | '/seeds'
    | '/p/$owner/$principalName'
    | '/peko/$owner/$pekoName'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/authorize'
    | '/dashboard'
    | '/device'
    | '/discover'
    | '/download'
    | '/pekos'
    | '/privacy'
    | '/profile'
    | '/search'
    | '/status'
    | '/terms'
    | '/$owner/$name'
    | '/@{$owner}/$name'
    | '/auth/callback'
    | '/bundles_/$'
    | '/dashboard_/runtimes'
    | '/dashboard_/seeds'
    | '/g/$id'
    | '/seeds/$'
    | '/seeds/new'
    | '/templates_/$'
    | '/@{$owner}/'
    | '/seeds/'
    | '/p/$owner/$principalName'
    | '/peko/$owner/$pekoName'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  AuthorizeRoute: typeof AuthorizeRoute
  DashboardRoute: typeof DashboardRoute
  DeviceRoute: typeof DeviceRoute
  DiscoverRoute: typeof DiscoverRoute
  DownloadRoute: typeof DownloadRoute
  PekosRoute: typeof PekosRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  SearchRoute: typeof SearchRoute
  StatusRoute: typeof StatusRoute
  TermsRoute: typeof TermsRoute
  OwnerNameRoute: typeof OwnerNameRoute
  AtChar123ownerChar125NameRoute: typeof AtChar123ownerChar125NameRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BundlesSplatRoute: typeof BundlesSplatRoute
  DashboardRuntimesRoute: typeof DashboardRuntimesRoute
  DashboardSeedsRoute: typeof DashboardSeedsRoute
  GIdRoute: typeof GIdRoute
  SeedsSplatRoute: typeof SeedsSplatRoute
  SeedsNewRoute: typeof SeedsNewRoute
  TemplatesSplatRoute: typeof TemplatesSplatRoute
  AtChar123ownerChar125IndexRoute: typeof AtChar123ownerChar125IndexRoute
  SeedsIndexRoute: typeof SeedsIndexRoute
  POwnerPrincipalNameRoute: typeof POwnerPrincipalNameRoute
  PekoOwnerPekoNameRoute: typeof PekoOwnerPekoNameRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pekos': {
      id: '/pekos'
      path: '/pekos'
      fullPath: '/pekos'
      preLoaderRoute: typeof PekosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discover': {
      id: '/discover'
      path: '/discover'
      fullPath: '/discover'
      preLoaderRoute: typeof DiscoverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authorize': {
      id: '/authorize'
      path: '/authorize'
      fullPath: '/authorize'
      preLoaderRoute: typeof AuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeds/': {
      id: '/seeds/'
      path: '/seeds'
      fullPath: '/seeds/'
      preLoaderRoute: typeof SeedsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/@{$owner}/': {
      id: '/@{$owner}/'
      path: '/@{$owner}'
      fullPath: '/@{$owner}/'
      preLoaderRoute: typeof AtChar123ownerChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates_/$': {
      id: '/templates_/$'
      path: '/templates/$'
      fullPath: '/templates/$'
      preLoaderRoute: typeof TemplatesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeds/new': {
      id: '/seeds/new'
      path: '/seeds/new'
      fullPath: '/seeds/new'
      preLoaderRoute: typeof SeedsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeds/$': {
      id: '/seeds/$'
      path: '/seeds/$'
      fullPath: '/seeds/$'
      preLoaderRoute: typeof SeedsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/g/$id': {
      id: '/g/$id'
      path: '/g/$id'
      fullPath: '/g/$id'
      preLoaderRoute: typeof GIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard_/seeds': {
      id: '/dashboard_/seeds'
      path: '/dashboard/seeds'
      fullPath: '/dashboard/seeds'
      preLoaderRoute: typeof DashboardSeedsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard_/runtimes': {
      id: '/dashboard_/runtimes'
      path: '/dashboard/runtimes'
      fullPath: '/dashboard/runtimes'
      preLoaderRoute: typeof DashboardRuntimesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bundles_/$': {
      id: '/bundles_/$'
      path: '/bundles/$'
      fullPath: '/bundles/$'
      preLoaderRoute: typeof BundlesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/@{$owner}/$name': {
      id: '/@{$owner}/$name'
      path: '/@{$owner}/$name'
      fullPath: '/@{$owner}/$name'
      preLoaderRoute: typeof AtChar123ownerChar125NameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$owner/$name': {
      id: '/$owner/$name'
      path: '/$owner/$name'
      fullPath: '/$owner/$name'
      preLoaderRoute: typeof OwnerNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/peko/$owner/$pekoName': {
      id: '/peko/$owner/$pekoName'
      path: '/peko/$owner/$pekoName'
      fullPath: '/peko/$owner/$pekoName'
      preLoaderRoute: typeof PekoOwnerPekoNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$owner/$principalName': {
      id: '/p/$owner/$principalName'
      path: '/p/$owner/$principalName'
      fullPath: '/p/$owner/$principalName'
      preLoaderRoute: typeof POwnerPrincipalNameRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  AuthorizeRoute: AuthorizeRoute,
  DashboardRoute: DashboardRoute,
  DeviceRoute: DeviceRoute,
  DiscoverRoute: DiscoverRoute,
  DownloadRoute: DownloadRoute,
  PekosRoute: PekosRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  SearchRoute: SearchRoute,
  StatusRoute: StatusRoute,
  TermsRoute: TermsRoute,
  OwnerNameRoute: OwnerNameRoute,
  AtChar123ownerChar125NameRoute: AtChar123ownerChar125NameRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BundlesSplatRoute: BundlesSplatRoute,
  DashboardRuntimesRoute: DashboardRuntimesRoute,
  DashboardSeedsRoute: DashboardSeedsRoute,
  GIdRoute: GIdRoute,
  SeedsSplatRoute: SeedsSplatRoute,
  SeedsNewRoute: SeedsNewRoute,
  TemplatesSplatRoute: TemplatesSplatRoute,
  AtChar123ownerChar125IndexRoute: AtChar123ownerChar125IndexRoute,
  SeedsIndexRoute: SeedsIndexRoute,
  POwnerPrincipalNameRoute: POwnerPrincipalNameRoute,
  PekoOwnerPekoNameRoute: PekoOwnerPekoNameRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
